import { createSelector } from 'reselect';

const getCustomProductButtonsConfig = (state) => {
    const { views: { view }, config = {} } = state;
    return config[view]?.customProductButtons ?? config?.customProductButtons ?? null;
};

export const getCustomProductButtonsConfigState = createSelector(
    [getCustomProductButtonsConfig],
    (customProductButtons) => {
        return { customProductButtons }
    }
);
